export const TERMINAL_ENABLED = true;
